import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { Severity } from '../models/severity';

@Directive({
  standalone: true,
  selector: '[appAlertStyle]',
})
export class AlertStyleDirective implements OnChanges {
  @Input() appAlertStyle!: Severity;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appAlertStyle']) {
      this.applyStyle(changes['appAlertStyle'].currentValue);
    }
  }

  // NG21-MIGRATION(stufe-2): setzt PrimeNG-17-DOM-Klassen (p-message-*) von Hand -> durch <p-message>/eigenes Alert-Atom ersetzen (§8.3)
  private applyStyle(type: Severity) {
    const classMap = {
      info: 'p-message-info',
      success: 'p-message-success',
      warning: 'p-message-warn',
      error: 'p-message-error',
      secondary: 'p-message-secondary',
      lock: 'p-message-lock',
      contrast: 'p-message-contrast',
    };
    this.clearClasses();
    this.renderer.addClass(this.el.nativeElement, 'p-message');
    this.renderer.addClass(this.el.nativeElement, 'p-card');
    this.renderer.addClass(this.el.nativeElement, classMap[type]);
  }

  private clearClasses() {
    this.renderer.removeClass(this.el.nativeElement, 'p-message-info');
    this.renderer.removeClass(this.el.nativeElement, 'p-message-success');
    this.renderer.removeClass(this.el.nativeElement, 'p-message-warn');
    this.renderer.removeClass(this.el.nativeElement, 'p-message-error');
    this.renderer.removeClass(this.el.nativeElement, 'p-message-secondary');
    this.renderer.removeClass(this.el.nativeElement, 'p-message-lock');
    this.renderer.removeClass(this.el.nativeElement, 'p-message-contrast');
  }
}
